import React from 'react'
import { Card, Button } from 'react-bootstrap'
import { User } from '../../../types/models/user'

// Add SVG icon for admin
const AdminIcon = () => (
  <svg width="50" height="50" viewBox="0 0 24 24" fill="currentColor" className="text-info">
    <path d="M12 14c-2.67 0-8 1.33-8 4v2h16v-2c0-2.67-5.33-4-8-4m0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0-10c3.31 0 6 2.69 6 6 0 3.32-2.69 6-6 6s-6-2.68-6-6c0-3.31 2.69-6 6-6Z" />
  </svg>
)

interface AdminAccountCardProps {
  currentUser: User | undefined
  gradient: string
  formatDate: (date: string) => string
}

const AdminAccountCard: React.FC<AdminAccountCardProps> = ({
  currentUser,
  gradient,
  formatDate,
}) => {
  if (!currentUser || currentUser.username !== 'admin') return null

  return (
    <Card bg="dark" text="white" className="mb-4">
      <Card.Header
        className="bg-info d-flex justify-content-between align-items-center"
        style={{ background: gradient }}
      >
        <h4 className="mb-0">System Administrator</h4>
        <div style={{ visibility: 'hidden' }}>
          <Button variant="light" disabled>
            <i className="fas fa-plus me-2"></i>Hidden Button
          </Button>
        </div>
      </Card.Header>
      <Card.Body>
        <div key={currentUser.id} className="d-flex flex-column">
          <div className="text-center mb-4">
            <div
              className="bg-info bg-opacity-25 rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
              style={{
                width: '100px',
                height: '100px',
                border: '3px solid var(--bs-info)',
              }}
            >
              <AdminIcon />
            </div>
            <h4 className="mb-1">{`${currentUser.first_name} ${currentUser.last_name}`}</h4>
            <div className="text-info text-opacity-75 mb-2">{currentUser.username}</div>
            <span className="badge bg-info text-dark">System Account</span>
          </div>

          <div className="border-top border-secondary pt-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <span className="text-light opacity-75">Email:</span>
              <span className="text-info text-opacity-75">{currentUser.email}</span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-light opacity-75">Last Login:</span>
              <span className="text-info text-opacity-75">
                {formatDate(currentUser.last_login || '')}
              </span>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}

export default AdminAccountCard
